import React from 'react';
import PropTypes from 'prop-types';
import { getMicrodata } from '@culture/common-helpers/microdata';

import _ from 'underscore';
import ActionContainer from 'components/Layout/components/ActionContainer';
import Breadcrumbs from 'components/Breadcrumbs';

import OnlyClient from 'components/OnlyClient';
import styles from './styles.module.scss';

// @TODO: refactoring Breadcrumbs, ActionContainer after applied component for all entitity pages

const BarEntity = ({
	breadcrumbs,
	entity,
	entityType,
	showEntityTitle = false
}) => {
	const breadcrumbsMicrodata =
		breadcrumbs && getMicrodata(breadcrumbs, 'breadcrumbs');

	return (
		<div className={styles.BarEntity}>
			{breadcrumbsMicrodata && !_.isEmpty(breadcrumbs) ? (
				<Breadcrumbs
					microdata={breadcrumbsMicrodata}
					items={breadcrumbs}
					currentEntityTitle={showEntityTitle ? entity?.title : null}
				/>
			) : null}

			<OnlyClient>
				<ActionContainer
					customSocialButtonsOrder="vkontakte,odnoklassniki,telegram,whatsapp"
					entity={entity}
					entityType={entityType}
					isStaticPosition
				/>
			</OnlyClient>
		</div>
	);
};

BarEntity.propTypes = {
	breadcrumbs: PropTypes.arrayOf(PropTypes.object),
	entity: PropTypes.object.isRequired,
	entityType: PropTypes.string.isRequired,
	showEntityTitle: PropTypes.bool
};

export default BarEntity;
